const MASK_FORMAT = {
  '*': '[*]',
  0: '[0-9]',
  A: '[\\w@\\-.+]',
};

const MOBILE_SHOW_LOGO = ['start', 'done', 'error'];

const CREDIT_CARD_MAP = {
  amex: 'AMERICAN_EXPRESS',
  dc: 'DINERS_CLUB',
  disc: 'DISCOVER',
  jcb: 'JCB',
  mc: 'MASTERCARD',
  visa: 'VISA',
};

const VALIDATION_STATUS = {
  MOBILE_VALIDATION_DECLINED: 'MOBILE_VALIDATION_DECLINED',
  MOBILE_VALIDATION_INCONCLUSIVE: 'MOBILE_VALIDATION_INCONCLUSIVE',
  SELECT_ADDRESS: 'SELECT_ADDRESS',
  SEND_VERIFICATION: 'SEND_VERIFICATION',
};

export { MASK_FORMAT, MOBILE_SHOW_LOGO, CREDIT_CARD_MAP, VALIDATION_STATUS };
